// extracted by mini-css-extract-plugin
module.exports = {"root":"Details_root__JXQln"};